export type Theme = 'light' | 'dark' | 'system';

const KEY = 'cx_theme';

export function getCurrent(): Theme {
    return (localStorage.getItem(KEY) as Theme | null) ?? 'system';
}

export function apply(theme: Theme): void {
    const html = document.documentElement;
    if (theme === 'system') {
        html.removeAttribute('data-bs-theme');
        localStorage.removeItem(KEY);
    } else {
        html.setAttribute('data-bs-theme', theme);
        localStorage.setItem(KEY, theme);
    }
    sincronizarBotoes(theme);
}

export function init(): void {
    sincronizarBotoes(getCurrent());
    document.querySelectorAll<HTMLElement>('[data-theme-set]').forEach(botao => {
        botao.addEventListener('click', () => apply(botao.dataset.themeSet as Theme));
    });
}

function sincronizarBotoes(theme: Theme): void {
    document.querySelectorAll<HTMLElement>('[data-theme-set]').forEach(botao => {
        botao.classList.toggle('active', botao.dataset.themeSet === theme);
    });
}
